import { prefersReducedMotion } from '@theme/utilities';

/**
 * Homepage scroll-reveal effect.
 *
 * As each of these sections scrolls into view, it fades in while sliding
 * leftward into place (see the `.scroll-reveal` rules in base.css).
 * The hero is intentionally excluded — it's already in view on load, so a
 * scroll-triggered reveal wouldn't read as a scroll effect.
 *
 * These are the fixed section ids from templates/index.json. If sections are
 * added, removed, or renamed there, update this list to match.
 */
const SECTION_IDS = [
  'shopify-section-category_grid_01',
  'shopify-section-definition_01',
  'shopify-section-bestsellers_01',
  'shopify-section-story_01',
  'shopify-section-home_setups_01',
  'shopify-section-testimonials_01',
  'shopify-section-newsletter_01',
];

function init() {
  const targets = SECTION_IDS.map((id) => document.getElementById(id)).filter(
    (/** @type {HTMLElement | null} */ el) => el !== null
  );

  if (!targets.length) return;

  if (prefersReducedMotion()) {
    // Skip the animation entirely, but keep content visible.
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('scroll-reveal-visible');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  targets.forEach((el) => {
    el.classList.add('scroll-reveal');
    observer.observe(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
